import type {DecorationPlugin} from '../../types'
import {pack} from './pack'

export const serdesPlugin = {
    name: 'SerdesPlugin',
    pack
} satisfies DecorationPlugin
